// this component is used to wrap a list of items eaither vertically or horizontally
// to animate it when its visible on the view
// it has a parameter to detect whether the list is horizontal or vertical 
// to either change the x axis or y axis depends on this parameter

"use client";
import { getListItemVariants, listContainerVariants } from "@/app/utils/variants/listVariants";
import { motion } from "framer-motion";
import React from "react";


type Props = {
  isHorizontal?: boolean;
  children: React.ReactNode;
  className?: string;
  viewportAmount?: number;
}



export function AnimatedList({ isHorizontal = false, children, className, viewportAmount = 0.05 }: Props) {
  const itemVariants = getListItemVariants(isHorizontal);
  const containerVariants = listContainerVariants;
  return (
    <motion.ul
      style={{ listStyle: "none", padding: 0, margin: 0 }}
      className={className}
      variants={containerVariants}
      initial="hidden"
      whileInView="visible"
      viewport={{ once: true, amount: viewportAmount }}
    >
      {React.Children.map(children, (child) => (
        <motion.li variants={itemVariants}>
          {child}
        </motion.li>
      ))}
    </motion.ul>
  );
};